import { render, staticRenderFns } from "./paperDetail.vue?vue&type=template&id=25e1df6a&scoped=true"
import script from "./paperDetail.vue?vue&type=script&lang=js"
export * from "./paperDetail.vue?vue&type=script&lang=js"
import style0 from "./paperDetail.vue?vue&type=style&index=0&id=25e1df6a&prod&scoped=true&lang=less"
import style1 from "./paperDetail.vue?vue&type=style&index=1&id=25e1df6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e1df6a",
  null
  
)

export default component.exports